// import React, { useState } from 'react';
import { createUserData } from '@utilities/auth';
// import { resortData } from './menu/naman-resort';
// import { resortData } from './menu/chandan-hotel';
// import { resortData } from './menu/pamil-cafe';
// import { resortData } from './menu/pamil-stay';
// import { userData } from './menu/user-data';
// import NestedList from '@src/app/components/NestedList';
import { Button } from '@mui/material';
// import List from '@src/app/components/NestedList/List';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs, { Dayjs } from 'dayjs';
// import moment from 'moment';


const CreateUser = () => {
    function createUser() {
        const userData:any = {
            // create a new user
        };
        // var connectionName = "users"; // stage: change it to restaurants for production
        console.log('Nice! Creating users... Commented code...');
        // createCollection(connectionName, resortData);
        // console.log('Nice! Created...');
        let count = 1;
        for (let userId in userData) {
            // console.log('userId----', userId, userData[userId]);
            if(userId){

                setTimeout(()=>{
                    createUserData(userId, userData[userId]);
                }, 1000*count);
                count++;
            }
        }
    }

    return (
        <div>
            <Button
                fullWidth
                onClick={() => createUser()}
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
            >
                Create Users
            </Button>
        </div>
    );
}

export default CreateUser;
